import { render, staticRenderFns } from "./NormalHeader.vue?vue&type=template&id=145541e8&scoped=true"
import script from "./NormalHeader.vue?vue&type=script&lang=js"
export * from "./NormalHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145541e8",
  null
  
)

export default component.exports